import _ from "lodash";
import { inject, observer } from "mobx-react";
import React from "react";
import className from "../../shared/className";
import { MODULE_ID } from "../../shared/moduleIds";
import AbstractPatients from "../Patients/AbstractPatients";
import PatientList from "../Surveil/PatientList";
import "./ObSurveil.scss";
import ObSurveilPatient from "./ObSurveilPatient";
import ObSurveilStore from "./ObSurveilStore";
import PatientListItem from "./PatientList/PatientListItem";
import SideNavLink from "./SideNavLink";
import ObSelectedPatient from "./ObSelectedPatient";
import ErrorBoundary from "../../shared/ErrorBoundary";
import Loader from "../../shared/Loader";

class ObSurveil extends AbstractPatients {
  surveil = true;
  constructor(props) {
    super(props);
    const appStore = this.props.store;
    this.store = new ObSurveilStore({
      listIndex: _.get(this.props.match, "params.listIndex"),
      appStore,
    });
  }

  render() {
    return (
      <div className="ob-surveil widget">
        {this.SubNav({ GroupSort: "disabled" })}
        {this.store.loadingConfig ? (
          <Loader />
        ) : (
          <div className="with-sidenav">
            <div className="side-nav">
              {[
                {
                  href: "patient-list",
                  selected: this.store.showPatientList,
                  icon: "list",
                  onClick: this.togglePatientList,
                },
                {
                  href: "4",
                  selected: this.store.layout === "4",
                  text: "4",
                  onClick: this.selectLayout,
                },
                {
                  href: "6",
                  selected: this.store.layout === "6",
                  text: "6",
                  onClick: this.selectLayout,
                },
                {
                  href: "12",
                  selected: this.store.layout === "12",
                  text: "12",
                  onClick: this.selectLayout,
                },
              ].map((props) => (
                <SideNavLink {...props} key={props.href} />
              ))}
              <div className="patient-list-mask"></div>
              <PatientList
                show={this.store.showPatientList}
                surveilStore={this.store}
                lists={this.store.lists.filter(
                  (list) => list.moduleId === MODULE_ID.OBSTETRICS,
                )}
                ListItem={PatientListItem}
                module={MODULE_ID.OBSTETRICS}
              />
            </div>
            <div
              {...className({
                "ob-surveil-inner": 1,
                [`split-${this.store.layout}`]: 1,
                "patient-selected": this.store.selectedPatient,
              })}
            >
              {this.store.loading ? (
                <Loader />
              ) : (
                <>
                  {this.store.selectedPatient ? (
                    <ErrorBoundary>
                      <ObSelectedPatient parent={this} store={this.store} />
                    </ErrorBoundary>
                  ) : null}
                  <ObSurveilPatients
                    store={this.store}
                    handleSelectPatient={this.handleSelectPatient}
                    patients={this.store.visibleObPatientsByLayout}
                  />
                </>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  handleSelectPatient = (e, patient) => {
    e.preventDefault();
    if (this.store?.selectedPatient?.asmpid !== patient?.asmpid) {
      this.store.selectedPatient = patient;
    } else {
      this.store.selectedPatient = null;
    }
  };

  selectLayout = (e) => {
    e.preventDefault();
    this.store.layout = e.currentTarget.getAttribute("href");
  };

  togglePHI = () => {
    this.store.togglePHI();
  };

  togglePatientList = (e) => {
    e.preventDefault();
    this.store.showPatientList = !this.store.showPatientList;
  };
}

export default inject("store")(observer(ObSurveil));

const ObSurveilPatients = ({ patients, store, handleSelectPatient }) => {
  return (
    <div className="patients">
      {patients
        ? patients.map((patient) => (
            <ObSurveilPatient
              obSurveilStore={store}
              patient={patient}
              selected={patient.asmpid === store.selectedPatient?.asmpid}
              selectedPatient={store.selectedPatient}
              key={patient.asmpid}
              moduleSpecifics={store.moduleSpecifics(patient)}
              onClick={(e) => handleSelectPatient(e, patient)}
            />
          ))
        : null}
    </div>
  );
};
